import {
  Box,
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import React, { useState } from "react";
import { RecommendationProductSearchModal } from "../../modals";

interface IProps {
  left: string[];
  right: string[];
  onLeftUpdate: (value: string[]) => void;
  onRightUpdate: (value: string[]) => void;
}

const TransferListComponent: React.FC<IProps> = ({
  left,
  right,
  onLeftUpdate,
  onRightUpdate,
}) => {
  const theme = useTheme();
  const [leftOpen, setLeftOpen] = useState(false);
  const [rightOpen, setRightOpen] = useState(false);

  const [leftText, setLeftText] = useState("");
  const [rightText, setRightText] = useState("");

  const onLeftAdd = () => {
    onLeftUpdate([...left, leftText]);
    setLeftText("");
  };

  const onRightAdd = () => {
    onRightUpdate([...right, rightText]);
    setRightText("");
  };

  const onLeftDelete = (index: number) => {
    left.splice(index, 1);
    onLeftUpdate([...left]);
  };

  const onRightDelete = (index: number) => {
    right.splice(index, 1);
    onRightUpdate([...right]);
  };

  return (
    <Box>
      <Grid
        container
        spacing={4}
        style={{ display: "flex", alignItems: "center" }}
      >
        <Grid item xs={12} md={6}>
          <Typography color="textSecondary">I Like...</Typography>
          <Box display="flex" flexGrow={1} alignItems="center" my={1}>
            <TextField
              variant="outlined"
              placeholder="Document id"
              margin="dense"
              fullWidth
              value={leftText}
              onChange={(e) => setLeftText(e.target.value)}
              style={{
                backgroundColor: "white",
                borderTopLeftRadius: 4,
                borderBottomLeftRadius: 4,
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <Button
              color="primary"
              variant="contained"
              disableRipple
              disabled={!leftText}
              disableElevation
              onClick={onLeftAdd}
              style={{
                textTransform: "none",
                backgroundColor: theme.palette.primary.main,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                paddingTop: theme.spacing(),
                paddingBottom: theme.spacing(),
              }}
            >
              Add
            </Button>
          </Box>

          <Box
            my={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography color="textSecondary">Or</Typography>
            <RecommendationProductSearchModal
              open={leftOpen}
              multiSelect
              onClose={() => setLeftOpen(false)}
              onAdd={(values) => onLeftUpdate([...left, ...values])}
            />
            <Button
              style={{
                textTransform: "none",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                marginTop: theme.spacing(),
                marginBottom: theme.spacing(),
              }}
              onClick={() => setLeftOpen(true)}
              color="primary"
              disableElevation
              disableRipple
            >
              Search from database
            </Button>
          </Box>
          <Box boxShadow={5} p={2} my={2} height={200} overflow="auto">
            {left.length ? (
              <List>
                {left.map((element, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={`${index + 1}. ${element}`}
                      style={{ color: theme.palette.common.white }}
                    />
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => onLeftDelete(index)}>
                        <Delete color="error" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexGrow={1}
              >
                <Typography color="textSecondary" align="center">
                  Add some ids to get results
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography color="textSecondary">I dont't like...</Typography>
          <Box display="flex" flexGrow={1} alignItems="center" my={1}>
            <TextField
              variant="outlined"
              placeholder="Document id"
              margin="dense"
              fullWidth
              value={rightText}
              onChange={(e) => setRightText(e.target.value)}
              style={{
                backgroundColor: "white",
                borderTopLeftRadius: 4,
                borderBottomLeftRadius: 4,
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <Button
              color="primary"
              variant="contained"
              disableRipple
              disabled={!rightText}
              disableElevation
              onClick={onRightAdd}
              style={{
                textTransform: "none",
                backgroundColor: theme.palette.primary.main,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                paddingTop: theme.spacing(),
                paddingBottom: theme.spacing(),
              }}
            >
              Add
            </Button>
          </Box>

          <Box
            my={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography color="textSecondary">Or</Typography>
            <RecommendationProductSearchModal
              open={rightOpen}
              multiSelect
              onClose={() => setRightOpen(false)}
              onAdd={(values) => onRightUpdate([...right, ...values])}
            />
            <Button
              style={{
                textTransform: "none",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                marginTop: theme.spacing(),
                marginBottom: theme.spacing(),
              }}
              onClick={() => setRightOpen(true)}
              color="primary"
              disableElevation
              disableRipple
            >
              Search from database
            </Button>
          </Box>
          <Box boxShadow={5} p={2} my={2} height={200} overflow="auto">
            {right.length ? (
              <List>
                {right.map((element, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={`${index + 1}. ${element}`}
                      style={{ color: theme.palette.common.white }}
                    />
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => onRightDelete(index)}>
                        <Delete color="error" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexGrow={1}
              >
                <Typography color="textSecondary" align="center">
                  Add some ids to get results
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TransferListComponent;
